/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useListChallengedScoredScenes = () => {

    // State storage of the challenged scored scenes shown in the table
    const [challengedScoredScenes, setChallengedScoredScenes] = useState([])
    const [challengedDecisionsNumbers, setChallengedDecisionsNumbers] = useState([])

    // Loading indication
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);

    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    useEffect(() => {
        fetchChallengedScoredScenes()
            .then(() => updateChallengedDecisionsNumberOfScoredScenes())
    }, [])


    // Retrieving the already existing videos
    const fetchChallengedScoredScenes = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/challengedScoredScenes?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const challengedScoredScenes = await data.json();
                setChallengedScoredScenes(challengedScoredScenes)

                return challengedScoredScenes
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.challengedDecision.messages.challengedScoredScenes.list.error',
                        defaultMessage: 'Something went wrong while listing the challenged video scenes: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const updateChallengedDecisionsNumberOfScoredScenes = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/challengedDecisions/functions/groupByScoredScene?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const numbersList = await data.json();
                setChallengedDecisionsNumbers(numbersList)
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.challengedDecision.messages.challengedDecisionsNumbers.list.error',
                        defaultMessage: 'Something went wrong while loading the numbers of challenged decisions: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
    }

    return {challengedScoredScenes, loading, challengedDecisionsNumbers, updateChallengedDecisionsNumberOfScoredScenes}
}
export default useListChallengedScoredScenes;